// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".tracking{\n  width:100%;\n  height:640px\n}\n\n.tracking_map{\n  width:100%;\n  height:100%;\n  overflow:hidden\n}", "",{"version":3,"sources":["/rails/app/javascript/components/tracking/tracking.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA;AAAA;;AAGJ;EACI,UAAA;EACA,WAAA;EACA;AAAA","file":"tracking.scss","sourcesContent":[".tracking{\n    width: 100%;\n    height: 640px;\n}\n\n.tracking_map{\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n"]}]);
// Exports
module.exports = exports;
